export default {
  loyalty:
    'Я принимаю условия <a target="_blank" href="{link}">программы лояльности</a> партнеров RC Group',
  posOferta:
    'Я принимаю условия <a target="_blank" href="https://cdn.rc.today/storage/partners/common/docs/ru/pos/Договор%20о%20присоединении%20к%20RC%20POS.pdf">договора</a> сервиса RC POS',
  1: "Основная информация",
  2: "Персональная информация",
  3: "Юридическое лицо",
  haveAcc: "Есть аккаунт?",
  login: "Войти",

  mainInfo: {
    title: "Основная информация",
    promocode: "Промокод",
    country: "Страна",
    phone: "Номер телефона",
    checkbox:
      " Даю свое согласие на обработку персональных данных в соответствии\n" +
      "с <a download href='{link}'>Политикой конфиденциальности</a>",
    oferta: "Принимаю условия" + " <a download href='{link}'>Оферты</a>",
  },

  profileInfo: {
    title: "Персональная информация",
    firstName: "Имя",
    lastName: "Фамилия",
    middleName: "Отчество",
    email: "Почта",
    password: "Пароль",
    confPassword: "Повторите пароль",
    registerCode: "Код с почты",
    notSendCode: "Не пришел код ?",
    sendAgain: "Отправить повторно",
  },

  emailCode: {
    title: "Код подтверждения отправлен на вашу почту",
    subtitle: 'Если вы не получили письмо на "{mail}", проверьте папку «Спам»',
    emailCode: "Код с почты",
    sendAgainTime: "Отправить код повторно через ",
    dontSend: "Не пришел код?",
    sendAgain: "Отправить повторно",
  },

  entity: {
    title: "Юридическое лицо",
    subTitle:
      "Пожалуйста, перед нажатием на кнопку «Далее», проверьте введенные данные",
    entityType: "Тип юрлица",
    halalCertificate: "Юрлицо имеет сертификат Халяль",
    fileType: "PNG, JPG, PDF - 1 файл до 10 Мб",
    commercial: "Коммерческое",
    checkbox: "Юрлицо занимается предпринимательской деятельностью",
  },

  payment: {
    title: "Спасибо за регистрацию!",
    subtitle:
      "Теперь вы можете попасть в личный кабинет программы лояльности RC Group.",
    moderation:
      "В данный момент ваше юрлицо проходит модерацию. Как правило, проверка занимает от 24 до 48 часов",
    examination:
      "Для прохождения проверки вам необходимо оплатить счет с указанного юрлица, скачав его по кнопке ниже. Вы также можете найти счет в личном кабинете: в разделе «Мои предприятия» - «Документы» под названием «Тестовый платеж».",

    goToCabinet: "Перейти в кабинет",
    alternativeCheck: {
      button: "Альтернативное прохождение проверки.",
      description:
        "Вам необходимо будет скачать документ “Анкета-заявление”, подписать, поставить печать и отправить на почту компании.",
    },
  },

  alternativePayment: {
    title: "Если нет возможности оплатить счет",
    signDocAndSendToMail:
      "Для прохождения проверки вам необходимо подписать документ, скачав его по кнопке ниже, и загрузить на данную страницу или отправить на почту <b>hello@rc.city</b>",
    whereIsDoc:
      "Вы также можете найти документ в личном кабинете: в разделе «Мои предприятия» — «Документы» под названием «Анкета - подтверждение юрлица»",
    downloadFileName: "Анкета-заявление",
    useMainCheckWay: "Использовать основной способ прохождения проверки",
    paymentInvoice: "Счет на оплату",
  },
};
